import React from "react";
import { useMyAccount } from "../../../context";
import { PlainTextInput } from "../TextInput/TextInput";
import * as styles from "./UserId.module.scss";

export const UserId: React.FC = () => {
	const { profile } = useMyAccount();
	return (
		<PlainTextInput
			id="user-id"
			type="hidden"
			className={styles.userId}
			aria-hidden="true"
			value={profile.userId}
		/>
	);
};
